import {
    getMessaging,
    getToken,
    onMessage
} from "firebase/messaging";

import {
    firebaseApp,
    db,
    auth
} from "../firebase";

import {
    doc,
    getDoc,
    setDoc,
    updateDoc,
    serverTimestamp
} from "../access/firestore";
import { isIOSDevice, waitForActiveServiceWorker } from "./serviceWorkerReady";

const defaultNotificationPreferences = {
    whatsappMessages: true,
    newAppointment: true,
    appointmentReminder15m: true
};


const VAPID_KEY =
    "BO0btPF6Ft4NRwqohA7rkaa3r6HWbpVzx7jJ9jSX8Wp7DWwe2lNjYNvCVCAlnYgbT3LpgIn3Pp1upqgl106ecyc";

const WEB_PUSH_VAPID_PUBLIC_KEY =
    "BH3q5VG-B2NPmYP5drK7ebRyYtsUEsaPn6RRcgISaeUfCEi9e-XjMPloEbh2mceFWw5qWQJ8eBr13W0FieIJ_fc";

let messagingInstance = null;


function getMessagingInstance() {

    if (!messagingInstance) {

        messagingInstance =
            getMessaging(
                firebaseApp
            );

    }

    return messagingInstance;

}

async function savePushToken(token) {

    try {

        const user =
            auth.currentUser;

        if (!user) {

            console.warn(
                "No hay usuario autenticado para guardar el token Push."
            );

            return;

        }

        const tokenRef =
            doc(
                db,
                "users",
                user.uid,
                "pushTokens",
                token
            );

        const tokenSnap =
            await getDoc(
                tokenRef
            );

        const tokenData = {

            token: token,

            lastSeenAt:
                serverTimestamp(),

            platform:
                navigator.platform || "",

            userAgent:
                navigator.userAgent || "",

            notificationPreferences: {
                ...defaultNotificationPreferences,
                ...(tokenSnap.exists() ? tokenSnap.data().notificationPreferences : {})
            }

        };

        if (
            !tokenSnap.exists()
        ) {

            tokenData.createdAt =
                serverTimestamp();

        }

        await setDoc(
            tokenRef,
            tokenData,
            {
                merge: true
            }
        );

        console.log(
            "VEXADENT PUSH TOKEN GUARDADO EN FIRESTORE"
        );

    } catch (error) {

        console.error(
            "Error guardando token Push en Firestore:",
            error
        );

    }

}

export async function updateNotificationPreferences(
    preferences
) {

    const user =
        auth.currentUser;

    if (!user) {
        return;
    }

    const isIOS = isIOSDevice();

    if (isIOS) {

        const registration =
            await navigator.serviceWorker.getRegistration(
                "/"
            );

        if (!registration) {
            return;
        }

        const subscription =
            await registration.pushManager
                .getSubscription();

        if (!subscription) {
            return;
        }

        const subscriptionId =
            btoa(
                subscription.endpoint
            )
                .replace(
                    /\+/g,
                    "-"
                )
                .replace(
                    /\//g,
                    "_"
                )
                .replace(
                    /=+$/,
                    ""
                );

        await updateDoc(
            doc(
                db,
                "users",
                user.uid,
                "webPushSubscriptions",
                subscriptionId
            ),
            {
                notificationPreferences:
                    preferences
            }
        );

        return;
    }

    const messaging =
        getMessagingInstance();

    const registration =
        await navigator.serviceWorker.getRegistration(
            "/"
        );

    if (!registration) {
        return;
    }

    const token =
        await getToken(
            messaging,
            {
                vapidKey:
                    VAPID_KEY,

                serviceWorkerRegistration:
                    registration
            }
        );

    if (!token) {
        return;
    }

    await updateDoc(
        doc(
            db,
            "users",
            user.uid,
            "pushTokens",
            token
        ),
        {
            notificationPreferences:
                preferences
        }
    );
}

export async function getNotificationPreferences() {

    const user =
        auth.currentUser;

    if (!user) {
        return null;
    }

    const isIOS = isIOSDevice();

    if (isIOS) {

        const registration =
            await navigator.serviceWorker.getRegistration(
                "/"
            );

        if (!registration) {
            return null;
        }

        const subscription =
            await registration.pushManager
                .getSubscription();

        if (!subscription) {
            return null;
        }

        const subscriptionId =
            btoa(
                subscription.endpoint
            )
                .replace(
                    /\+/g,
                    "-"
                )
                .replace(
                    /\//g,
                    "_"
                )
                .replace(
                    /=+$/,
                    ""
                );

        const snapshot =
            await getDoc(
                doc(
                    db,
                    "users",
                    user.uid,
                    "webPushSubscriptions",
                    subscriptionId
                )
            );

        if (!snapshot.exists()) {
            return null;
        }

        return (
            snapshot.data()
                .notificationPreferences ||
            null
        );
    }

    const messaging =
        getMessagingInstance();

    const registration =
        await navigator.serviceWorker.getRegistration(
            "/"
        );

    if (!registration) {
        return null;
    }

    const token =
        await getToken(
            messaging,
            {
                vapidKey:
                    VAPID_KEY,

                serviceWorkerRegistration:
                    registration
            }
        );

    if (!token) {
        return null;
    }

    const snapshot =
        await getDoc(
            doc(
                db,
                "users",
                user.uid,
                "pushTokens",
                token
            )
        );

    if (!snapshot.exists()) {
        return null;
    }

    return (
        snapshot.data()
            .notificationPreferences ||
        null
    );
}

export async function requestPushPermission() {

    if (
        typeof window ===
        "undefined"
    ) {
        return null;
    }


    if (
        !("Notification" in window)
    ) {

        console.warn(
            "Este dispositivo/navegador no soporta notificaciones."
        );

        return null;

    }

    if (!navigator.serviceWorker) return null;


    try {

        let permission =
            Notification.permission;


        if (
            permission ===
            "default"
        ) {

            permission =
                await Notification.requestPermission();

        }


        if (
            permission !==
            "granted"
        ) {

            console.warn(
                "El usuario no concedió permiso para notificaciones."
            );

            return null;

        }


        const isIOS = isIOSDevice();


        /*
         * iPhone / iPad:
         * Web Push nativo de Safari/iOS.
         */
        if (isIOS) {

            const registration =
                await navigator.serviceWorker.register(
                    "/push-sw.js",
                    {
                        scope: "/"
                    }
                );


            await waitForActiveServiceWorker(registration);


            let subscription =
                await registration.pushManager
                    .getSubscription();


            if (!subscription) {

                subscription =
                    await registration.pushManager
                        .subscribe({
                            userVisibleOnly:
                                true,

                            applicationServerKey:
                                WEB_PUSH_VAPID_PUBLIC_KEY
                        });

            }


            const user =
                auth.currentUser;


            if (!user) {

                console.warn(
                    "No hay usuario autenticado para guardar la suscripción Web Push."
                );

                return null;

            }


            const subscriptionData =
                subscription.toJSON();


            const subscriptionId =
                btoa(
                    subscription.endpoint
                )
                    .replace(
                        /\+/g,
                        "-"
                    )
                    .replace(
                        /\//g,
                        "_"
                    )
                    .replace(
                        /=+$/,
                        ""
                    );


            const subscriptionRef =
                doc(
                    db,
                    "users",
                    user.uid,
                    "webPushSubscriptions",
                    subscriptionId
                );

            const previousSubscription = await getDoc(subscriptionRef);


            await setDoc(
                subscriptionRef,
                {
                    endpoint:
                        subscriptionData.endpoint,

                    expirationTime:
                        subscriptionData.expirationTime ||
                        null,

                    keys:
                        subscriptionData.keys,

                    platform:
                        navigator.platform ||
                        "",

                    userAgent:
                        navigator.userAgent ||
                        "",

                    notificationPreferences: {
                        ...defaultNotificationPreferences,
                        ...(previousSubscription.exists() ? previousSubscription.data().notificationPreferences : {})
                    },

                    lastSeenAt:
                        serverTimestamp(),

                    createdAt:
                        serverTimestamp()
                },
                {
                    merge: true
                }
            );


            console.log(
                "VEXADENT WEB PUSH SUBSCRIPTION GUARDADA"
            );


            return subscription;

        }


        /*
         * Mac / Chrome y demás navegadores
         * continúan utilizando Firebase Cloud Messaging.
         */
        const messaging =
            getMessagingInstance();


        const registration =
            await navigator.serviceWorker.register(
                "/firebase-messaging-sw.js",
                {
                    scope: "/"
                }
            );

        await waitForActiveServiceWorker(registration);

        const token =
            await getToken(
                messaging,
                {
                    vapidKey:
                        VAPID_KEY,

                    serviceWorkerRegistration:
                        registration
                }
            );


        if (!token) {

            console.warn(
                "Firebase no devolvió un FCM token."
            );

            return null;

        }


        console.log(
            "VEXADENT FCM TOKEN:",
            token
        );


        await savePushToken(
            token
        );


        return token;

    } catch (error) {

        console.error(
            "Error registrando notificaciones push:",
            error
        );

        return null;

    }

}

export function listenToForegroundMessages(
    callback
) {

    try {

        const isIOS = isIOSDevice();

        if (isIOS) {
            return () => {};
        }

        const messaging =
            getMessagingInstance();


        const unsubscribe = onMessage(
            messaging,
            payload => {

                console.log(
                    "VEXADENT PUSH RECIBIDO:",
                    payload
                );

                if (callback) {

                    callback(
                        payload
                    );

                }

            }
        );

        console.log(
            "VEXADENT FOREGROUND LISTENER REGISTRADO"
        );

        return unsubscribe;

    } catch (error) {

        console.error(
            "Error escuchando mensajes push:",
            error
        );

        return () => {};

    }

}
